module.exports = __webpack_public_path__ + "media/components/sessions/registration-form/img/gauge_Icon_2-e92fa19cf387d7e0a57d6468daed3332.svg";